// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ConsultingDialog_TheComp__cl_zQ"};